var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.routeName))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/groups", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.createGroup.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "row justify-content-md-center" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.groupTitle,
                          expression: "rules.groupTitle"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Group Title",
                        placeholder: "Enter Title",
                        "data-vv-name": "title",
                        "cus-name": "title",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.group.groupTitle,
                        callback: function($$v) {
                          _vm.$set(_vm.group, "groupTitle", $$v)
                        },
                        expression: "group.groupTitle"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.groupDescription,
                          expression: "rules.groupDescription"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Group Description",
                        placeholder: "Enter Description",
                        "data-vv-name": "description",
                        "cus-name": "description",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.group.groupDescription,
                        callback: function($$v) {
                          _vm.$set(_vm.group, "groupDescription", $$v)
                        },
                        expression: "group.groupDescription"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.interests.length
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("label", [
                          _vm._v("Select Group Interests    "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectAllInterest,
                                expression: "selectAllInterest"
                              }
                            ],
                            staticClass: "form-input",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.selectAllInterest)
                                ? _vm._i(_vm.selectAllInterest, null) > -1
                                : _vm.selectAllInterest
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.selectAllInterest,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectAllInterest = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectAllInterest = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectAllInterest = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" Select All")
                        ]),
                        _vm._v(" "),
                        _vm.interests
                          ? _c(
                              "multiselect",
                              {
                                attrs: {
                                  disabled: _vm.selectAllInterest,
                                  placeholder: "Select Interests",
                                  multiple: true,
                                  options: _vm.interests.map(function(type) {
                                    return type.interestId
                                  }),
                                  "custom-label": function(opt) {
                                    return _vm.interests.find(function(x) {
                                      return x.interestId == opt
                                    }).interest
                                  },
                                  required: ""
                                },
                                model: {
                                  value: _vm.group.csvGroupInterestsId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.group,
                                      "csvGroupInterestsId",
                                      $$v
                                    )
                                  },
                                  expression: "group.csvGroupInterestsId"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            >\n                "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.experts.length
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("label", [
                          _vm._v("Select Group Experts  "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectAllExpert,
                                expression: "selectAllExpert"
                              }
                            ],
                            staticClass: "form-input",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.selectAllExpert)
                                ? _vm._i(_vm.selectAllExpert, null) > -1
                                : _vm.selectAllExpert
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.selectAllExpert,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectAllExpert = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectAllExpert = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectAllExpert = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" Select All\n                  ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "multiselect",
                          {
                            attrs: {
                              disabled: _vm.selectAllExpert,
                              placeholder: "Select Experts",
                              multiple: true,
                              options: _vm.experts.map(function(type) {
                                return type.expertId
                              }),
                              "custom-label": function(opt) {
                                return _vm.experts.find(function(x) {
                                  return x.expertId == opt
                                }).name
                              },
                              required: ""
                            },
                            model: {
                              value: _vm.group.csvGroupExpertsId,
                              callback: function($$v) {
                                _vm.$set(_vm.group, "csvGroupExpertsId", $$v)
                              },
                              expression: "group.csvGroupExpertsId"
                            }
                          },
                          [
                            _vm._v(
                              "\n                    >\n                  "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tendingPlaylists.length
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("label", [
                          _vm._v("Select Group Trending Playlists "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectAllPlaylists,
                                expression: "selectAllPlaylists"
                              }
                            ],
                            staticClass: "form-input",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.selectAllPlaylists)
                                ? _vm._i(_vm.selectAllPlaylists, null) > -1
                                : _vm.selectAllPlaylists
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.selectAllPlaylists,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectAllPlaylists = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectAllPlaylists = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectAllPlaylists = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" Select All ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "multiselect",
                          {
                            attrs: {
                              disabled: _vm.selectAllPlaylists,
                              placeholder: "Select Trending Playlists",
                              multiple: true,
                              options: _vm.tendingPlaylists.map(function(type) {
                                return type.playlistId
                              }),
                              "custom-label": function(opt) {
                                return _vm.tendingPlaylists.find(function(x) {
                                  return x.playlistId == opt
                                }).playlistTitle
                              },
                              required: ""
                            },
                            model: {
                              value: _vm.group.csvGroupTrendPlaylistId,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.group,
                                  "csvGroupTrendPlaylistId",
                                  $$v
                                )
                              },
                              expression: "group.csvGroupTrendPlaylistId"
                            }
                          },
                          [_vm._v("\n                  >\n                ")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.articles.length
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("label", [
                          _vm._v("Select Group Articles "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectAllArticle,
                                expression: "selectAllArticle"
                              }
                            ],
                            staticClass: "form-input",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.selectAllArticle)
                                ? _vm._i(_vm.selectAllArticle, null) > -1
                                : _vm.selectAllArticle
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.selectAllArticle,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectAllArticle = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectAllArticle = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectAllArticle = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" Select All")
                        ]),
                        _vm._v(" "),
                        _c(
                          "multiselect",
                          {
                            attrs: {
                              disabled: _vm.selectAllArticle,
                              placeholder: "Select TONE Articles",
                              multiple: true,
                              options: _vm.articles.map(function(type) {
                                return type.toneArticleId
                              }),
                              "custom-label": function(opt) {
                                return _vm.articles.find(function(x) {
                                  return x.toneArticleId == opt
                                }).articleHead
                              },
                              required: ""
                            },
                            model: {
                              value: _vm.group.csvGroupArticlesId,
                              callback: function($$v) {
                                _vm.$set(_vm.group, "csvGroupArticlesId", $$v)
                              },
                              expression: "group.csvGroupArticlesId"
                            }
                          },
                          [_vm._v("\n                  >\n                ")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tags.length
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("label", [_vm._v("Select/Add Custom Tags")]),
                        _vm._v(" "),
                        _vm.tags
                          ? _c(
                              "multiselect",
                              {
                                attrs: {
                                  "tag-placeholder": "Add this as new Tag",
                                  placeholder: "Select or Add Tags",
                                  multiple: true,
                                  label: "tagKey",
                                  "track-by": "tagKey",
                                  taggable: true,
                                  options: _vm.tags,
                                  required: ""
                                },
                                on: { tag: _vm.addTag },
                                model: {
                                  value: _vm.selectedTags,
                                  callback: function($$v) {
                                    _vm.selectedTags = $$v
                                  },
                                  expression: "selectedTags"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  >\n                "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-md-3",
                    style: { color: _vm.group.headerColor }
                  },
                  [
                    _c("fg-input", {
                      attrs: {
                        type: "text",
                        label: "Header Color",
                        placeholder: "Enter Color Code"
                      },
                      model: {
                        value: _vm.group.headerColor,
                        callback: function($$v) {
                          _vm.$set(_vm.group, "headerColor", $$v)
                        },
                        expression: "group.headerColor"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-md-3",
                    style: { color: _vm.group.footerColor }
                  },
                  [
                    _c("fg-input", {
                      attrs: {
                        type: "text",
                        label: "Footer Color",
                        placeholder: "Enter Color Code"
                      },
                      model: {
                        value: _vm.group.footerColor,
                        callback: function($$v) {
                          _vm.$set(_vm.group, "footerColor", $$v)
                        },
                        expression: "group.footerColor"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-md-3",
                    style: { color: _vm.group.buttonColor }
                  },
                  [
                    _c("fg-input", {
                      attrs: {
                        type: "text",
                        label: "Button Color",
                        placeholder: "Enter Color Code"
                      },
                      model: {
                        value: _vm.group.buttonColor,
                        callback: function($$v) {
                          _vm.$set(_vm.group, "buttonColor", $$v)
                        },
                        expression: "group.buttonColor"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-md-3",
                    style: { color: _vm.group.headingColor }
                  },
                  [
                    _c("fg-input", {
                      attrs: {
                        type: "text",
                        label: "Heading Color",
                        placeholder: "Enter Color Code"
                      },
                      model: {
                        value: _vm.group.headingColor,
                        callback: function($$v) {
                          _vm.$set(_vm.group, "headingColor", $$v)
                        },
                        expression: "group.headingColor"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      attrs: {
                        type: "number",
                        min: "15",
                        label: "Min Limit for Work Menu",
                        placeholder: "Enter Number"
                      },
                      model: {
                        value: _vm.group.minVidReqdWork,
                        callback: function($$v) {
                          _vm.$set(_vm.group, "minVidReqdWork", $$v)
                        },
                        expression: "group.minVidReqdWork"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      attrs: {
                        type: "number",
                        min: "15",
                        label: "Min Limit for Life Menu",
                        placeholder: "Enter Number"
                      },
                      model: {
                        value: _vm.group.minVidReqdLife,
                        callback: function($$v) {
                          _vm.$set(_vm.group, "minVidReqdLife", $$v)
                        },
                        expression: "group.minVidReqdLife"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      attrs: {
                        type: "number",
                        min: "15",
                        label: "Min Limit for Mindbody Menu",
                        placeholder: "Enter Number"
                      },
                      model: {
                        value: _vm.group.minVidReqdMindBody,
                        callback: function($$v) {
                          _vm.$set(_vm.group, "minVidReqdMindBody", $$v)
                        },
                        expression: "group.minVidReqdMindBody"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      attrs: {
                        type: "number",
                        min: "15",
                        label: "Min Limit for Money Menu",
                        placeholder: "Enter Number"
                      },
                      model: {
                        value: _vm.group.minVidReqdMoney,
                        callback: function($$v) {
                          _vm.$set(_vm.group, "minVidReqdMoney", $$v)
                        },
                        expression: "group.minVidReqdMoney"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.status.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("fg-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.active,
                              expression: "rules.active"
                            }
                          ],
                          attrs: {
                            label: "Active",
                            "data-vv-name": "active",
                            "cus-name": "active",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields,
                            list: _vm.status,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.group.active,
                            callback: function($$v) {
                              _vm.$set(_vm.group, "active", $$v)
                            },
                            expression: "group.active"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 text-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-fill btn-block",
                  attrs: { type: "submit", disabled: _vm.errors.any() }
                },
                [_vm._v("\n              Create Group\n            ")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b61dfd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b61dfd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Groups/CreateGroup.vue
// module id = 0Iyz
// module chunks = 0